import { RequestModelInterface } from "@/service/models/request-model-interface";
import { ResponseModelInterfaceStatic } from "@/service/models/response-model-interface";
import { XmlDecodingException } from "@/utilities/exceptions/xml-decoding-exception";
import { staticImplements } from "@/utilities/static-implements";
import { XmlDocumentWrapper } from "@/utilities/xml-helpers/xml-document-wrapper";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";
import { BaseDosageChoice } from "./dosage-choices";
import { DosageLoop } from "./parts/dosage-loop";
import { DosageSteadyState } from "./parts/dosage-steady-state";

@staticImplements<ResponseModelInterfaceStatic>()
export class QueryDosage implements RequestModelInterface
{
    public constructor(
        public dosageRepeat: DosageSteadyState|DosageLoop|BaseDosageChoice
    )
    {
    }

    public static makeFromXml(elem: XmlElementWrapper): QueryDosage
    {
        const dosageSteadyStateElem = elem.firstChildByTagOrNull("dosageSteadyState");
        const dosageLoopElem = elem.firstChildByTagOrNull("dosageLoop");
        const dosageChoiceElem = elem.firstChildWithTagInOrNull(BaseDosageChoice.allowedTagNames);

        if (dosageSteadyStateElem) {
            return new this(DosageSteadyState.makeFromXml(dosageSteadyStateElem));
        }

        if (dosageLoopElem) {
            return new this(DosageLoop.makeFromXml(dosageLoopElem));
        }

        if (dosageChoiceElem) {
            return new this(BaseDosageChoice.makeFromXmlGeneric(dosageChoiceElem));
        }

        const allowedTagNames = new Array<string>().concat("dosageSteadyState", "dosageLoop", ...BaseDosageChoice.allowedTagNames);
        throw XmlDecodingException.noRequiredChildFound(elem.element, allowedTagNames)
    }

    public getXml(doc: XmlDocumentWrapper): XmlElementWrapper
    {
        const element = doc.createElement("dosage");

        element.append(this.dosageRepeat.getXml(doc));

        return element;
    }

    public getInnerDosageChoice(): BaseDosageChoice
    {
        if (this.dosageRepeat instanceof DosageSteadyState) {
            return this.dosageRepeat.dosageChoice;
        }

        if (this.dosageRepeat instanceof DosageLoop) {
            return this.dosageRepeat.dosageChoice;
        }

        return this.dosageRepeat;
    }
}
